import { NgModule, inject, Injector } from '@angular/core';
import { CommonModule, LOCATION_INITIALIZED } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { TranslateModule, TranslateService, TranslateCompiler } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { TranslateMessageFormatCompiler, MESSAGE_FORMAT_CONFIG } from 'ngx-translate-messageformat-compiler';
import { provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';

declare const VERSION: string;
@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: `.json?v=${VERSION}`
      }),
      fallbackLang: 'pl',
      compiler: { provide: TranslateCompiler, useClass: TranslateMessageFormatCompiler }
    })
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(initI18n),
    { provide: MESSAGE_FORMAT_CONFIG, useValue: { locales: ['pl', 'ru', 'en', 'de'] } }
  ],
  exports: [TranslateModule]
})
export class I18nModule { }

export async function initI18n(): Promise<void> {
  const injector = inject(Injector);
  const translate = inject(TranslateService);

  await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
  translate.addLangs(['pl', 'ru', 'en', 'de']);

  const browserLang = translate.getBrowserLang();
  const available = ['pl', 'ru', 'en', 'de'];
  const defaultLang = (browserLang && available.includes(browserLang)) ? browserLang : 'pl';

  translate.setDefaultLang(defaultLang);
  translate.setFallbackLang('pl');
  await firstValueFrom(translate.use(defaultLang));
}